declare module '*.st.css' {
  const stylesheet: import('@stylable/runtime').RuntimeStylesheet;
  export = stylesheet;
}
declare module 'react-module-container';
declare module 'is-ci' {
  export default boolean;
}
